import { useDispatch } from 'react-redux'
import { TemplateElement } from '@phrasee/phrasee-typings'
import cx from 'classnames'

import { useAppSelector } from 'common/hooks/redux'
import { isComponentElement } from 'features/futurama/api/interfaces'
import { workflowCardClicked } from 'features/futurama/store/contentSlice'

import { useContentOrTemplate } from '../../hooks'

import ActionsMenu from './ActionsMenu'
import CardIcon from './CardIcon'
import WorkflowCard from './WorkflowCard'
type Props = {
  element: TemplateElement
  isConfigurable?: boolean
}

const WorkflowTemplateCard = ({ element, isConfigurable }: Props) => {
  const dispatch = useDispatch()
  const { template } = useContentOrTemplate()
  const selectedElementId = useAppSelector(
    (state) => state.content.selectedElementId
  )
  const areElementsDisabled = useAppSelector(
    (state) => state.content.areElementsDisabled
  )

  const { icon, display_name, elements } = element

  const hasTemplate = !!template
  const isTemplateElementSelected = element.elements
    .filter(isComponentElement)
    .some((element) => element.element_id === selectedElementId)
  const isTemplateSelected = element.element_id === selectedElementId

  return (
    <div
      className={cx('p-4 border rounded-md group', {
        'border-orange-400': isTemplateElementSelected || isTemplateSelected,
        'border-coolGray-300': !isTemplateElementSelected,
        'bg-white': !areElementsDisabled,
        'bg-coolGray-100': areElementsDisabled,
      })}
    >
      <div className="flex mb-2">
        {icon && (
          <CardIcon
            icon={icon}
            className={cx({ 'text-orange-400': isTemplateElementSelected })}
          />
        )}
        <div
          className={cx('ml-4 text-base  font-medium overflow-hidden', {
            'text-coolGray-400': areElementsDisabled,
            'text-coolGray-800': !areElementsDisabled,
          })}
        >
          {display_name}
        </div>
        <ActionsMenu
          isConfigurable={isConfigurable || false}
          isDisabled={areElementsDisabled}
          isSelected={isTemplateSelected}
          element={element}
        />
      </div>
      {elements &&
        elements
          .filter(isComponentElement)
          .map(({ element_id, name, display_name, status }) => {
            const isElementDisabled =
              hasTemplate || areElementsDisabled || status === 'disabled'

            return (
              <WorkflowCard
                className="mb-2"
                key={element_id}
                title={display_name || name}
                isDisabled={isElementDisabled}
                isSelected={
                  selectedElementId === element_id && !isElementDisabled
                }
                onClick={() =>
                  !isElementDisabled &&
                  dispatch(
                    workflowCardClicked({
                      elementId: element_id,
                    })
                  )
                }
              />
            )
          })}
    </div>
  )
}

export default WorkflowTemplateCard
